<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <uda-list of="mobileLifeEventTypes" name="mobileLifeEventType" label-key="uda.mobileLifeEvent.severalSelected" {visible}="states.mobileLifeEventType"
                  class="inlineGroup"></uda-list>
    </field-item>
</div>
